import { Typography } from '../typography/typography';

export const Divider = ({ text }: { text?: string }) => {
  return (
    <div className="relative flex items-center">
      <div className="flex-grow border-t border-b-0 border-solid border-grey-200"></div>

      {text && (
        <>
          <span className="flex-shrink mx-4">
            <Typography type="text-md" className="uppercase text-grey-300">
              {text}
            </Typography>
          </span>
          <div className="flex-grow border-t border-b-0 border-solid border-grey-200"></div>
        </>
      )}
    </div>
  );
};
